import { useDispatch } from "react-redux";

import { authProviderActions } from "../../../store/auth/auth-provider";
import { useCallback } from "react";

function useSetTokenState() {
  const dispatch = useDispatch();

  const setToken = useCallback((authNew) => {
    dispatch(authProviderActions.setAuth(authNew));

    window.localStorage.setItem("user_auth", JSON.stringify(authNew));
  }, []);

  return setToken;
}

export default useSetTokenState;
